import { Progress } from '@mantine/core';
import { useFocusWithin, useInputState } from '@mantine/hooks';

import { Requirement } from './requirement';

const requirements = [
  { label: 'Includes number', regEx: /[0-9]/ },
  { label: 'Includes lowercase letter', regEx: /[a-z]/ },
  { label: 'Includes uppercase letter', regEx: /[A-Z]/ },
  { label: 'Includes special symbol', regEx: /[$&+,:;=?@#|'<>.^*()%!-]/ },
  { label: 'Has at least 6 characters', regEx: /^.{6,}$/ },
];

const getStrength = (password: string) => {
  let multiplier = password.length > 5 ? 0 : 1;

  requirements.forEach((requirement) => {
    if (!requirement.regEx.test(password)) {
      multiplier += 1;
    }
  });

  return Math.max(100 - (100 / (requirements.length + 1)) * multiplier, 0);
};

export const usePasswordWithRequirements = () => {
  const { ref, focused } = useFocusWithin();

  const [value, setValue] = useInputState('');
  const strength = getStrength(value);

  const checks = requirements.map((requirement, index) => (
    <Requirement
      key={index}
      label={requirement.label}
      meets={requirement.regEx.test(value)}
    />
  ));

  const bars = Array(4)
    .fill(0)
    .map((_, index) => (
      <Progress
        styles={{ section: { transitionDuration: '0ms' } }}
        value={
          value.length > 0 && index === 0
            ? 100
            : strength >= ((index + 1) / 4) * 100
              ? 100
              : 0
        }
        color={
          strength > 80 ? '#00ff82' : strength > 50 ? 'yellow' : '#ff008880'
        }
        key={index}
        size={5}
      />
    ));

  return { bars, checks, focused, ref, setValue, value };
};
